export function InitMobileMenu() {
    // Main Menu
    const mobileButton = document.querySelector('.site-header--main-nav--menu-button')

    // Get the header element with the class "site-header"
    const headerElement = document.querySelector('header.site-header');

    if (mobileButton) {
        // Add a click event listener to the toggle button
        mobileButton.addEventListener('click', () => {
            // Get the current value of the data attribute
            const currentValue = headerElement.getAttribute('data-menu-open');
        
            // Toggle the value between true and false
            const newValue = (currentValue === 'true') ? 'false' : 'true';
        
            // Update the data attribute value
            headerElement.setAttribute('data-menu-open', newValue);
        });
    }
}

export function InitMobileMenuSubMenus() {
    const mobileSubMenuToggles = document.querySelectorAll('.sub-menu-toggle');

    function toggleMobileSubMenu(button) {
        var subMenu = button.parentNode.nextElementSibling; // Get the next sibling element (the submenu)
        subMenu.classList.toggle('active'); // Toggle the 'active' class on the submenu
    }

    if (mobileSubMenuToggles) {
        // Add a click event listener to the toggle button
        mobileSubMenuToggles.forEach(button => {
            button.addEventListener('click', () => toggleMobileSubMenu(button));
        });
    }
}